module.exports = __webpack_public_path__ + "img/sercomm-view_reset.98a9a878.png";